import { QuestionType } from "../../../api/main/models/codeOnly/QuestionType";
import { DeleteQuestionBase } from "../DeleteQuestionBase";

/**
 * Delete a learning activity.
 */
export const DeleteLearning = () => (<DeleteQuestionBase defaultQuestionType={QuestionType.LearningVideo} />);
